document.addEventListener("DOMContentLoaded", function() {
  const images = document.querySelectorAll("img.clickable-image");
  images.forEach(image => {
    image.addEventListener("click", function() {
      // Toggle the expanded class to switch between 60% and 100% width
      this.classList.toggle("expanded");
    });
  });
});
